import { render } from "./BaseFnbTopNavMobile.vue?vue&type=template&id=54ac7d99&scoped=true"
import script from "./BaseFnbTopNavMobile.vue?vue&type=script&lang=js"
export * from "./BaseFnbTopNavMobile.vue?vue&type=script&lang=js"

import "./BaseFnbTopNavMobile.vue?vue&type=style&index=0&id=54ac7d99&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ac7d99"]])

export default __exports__